import { render, staticRenderFns } from "./NextTurn.vue?vue&type=template&id=0979e211&"
import script from "./NextTurn.vue?vue&type=script&lang=js&"
export * from "./NextTurn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports